<template>
  <CContainer>
    <h3>Productos Contrato de Arrendamiento</h3>
    <CCard class="mt-4">
      <CCardBody class="p-3">
        <CRow>
          <CCol col="sm-6">
            <CButton color="secondary" class="mb-3 mr-3" to="/empresa/movimientos/contratosarrendamientos">
              <i class="bi bi-arrow-left-circle h4 mr-2"></i>
              <span>Regresar</span>
            </CButton>
            <CButton color="success" class="mb-3"
              :to="`/empresa/movimientos/contratosarrendamientos/${contractId}/productosarrendamientos/agregar`">
              <i class="bi bi-plus-circle h4 mr-2"></i>
              <span>Agregar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable 
          hover 
          responsive
          :items="rentedProducts" 
          :fields="fields" 
          :items-per-page="5">
          <template #producto="{ item }">
            <td>
              <div>
                <span>{{ item.producto }}</span>
              </div>
              <div>
                <span>{{ item.codigo }}</span>
              </div>
              <div v-if="item.numero_Serial">
                <i class="bi bi-upc-scan mr-1"></i>
                <span>{{ item.numero_Serial }}</span>
              </div>
            </td>
          </template>
          <template #fechas="{ item }">
            <td>
              <div>
                <CIcon name="cil-calendar" class="mr-1" />
                <span>{{ item.fecha_Entrega }}</span>
              </div>
              <div>
                <CIcon name="cil-calendar" class="mr-1" />
                <span>{{ item.fecha_Entrega }}</span>
              </div>
            </td>
          </template>
          <template #valores="{ item }">
            <td>
              <div>
                <i class="bi bi-cash-coin mr-1"></i>
                <span>{{ formatter.format(item.valor_Arriendo, 0) }}</span>
              </div>
              <div>
                <i class="bi bi-folder2-open mr-1"></i>
                <span>{{ item.cantidad }}</span>
              </div>
            </td>
          </template>
          <template #estado="{ item }">
            <td align="center">
              <CIcon v-if="item.estado == 'A'" name="cil-check-circle" class=" m-1 text-success" />
              <CIcon v-if="item.estado == 'I'" name="cil-x-circle" class=" m-1 text-danger" />
            </td>
          </template>
          <template #options="{ item }">
            <td class="d-flex">
              <!-- <CButton 
                                color="warning"
                                square 
                                :to="`/empresa/movimientos/contratosarrendamientos/${rentContractIndex}/productosarrendamientos/editar/${item.index}`"
                                size="sm"
                                :block="false"
                                class="mr-2 mb-2">              
                                <CIcon name="cil-pencil" class="text-white"></CIcon>
                            </CButton> -->
              <a href="#" class="mr-3" v-c-tooltip="'Borrar Producto'"
                @click="tryDelete($event, item.id_ProductoArrendamiento)">
                <CIcon name="cil-trash" size="lg" class="text-danger" />
              </a>
            </td>
          </template>
        </CDataTable>
        <CPagination
          size="sm"
          class="d-flex justify-content-center"
          :activePage.sync="page"
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)">
        </CPagination>  
      </CCardBody>

      <LoadingCover v-show="loading" />
    </CCard>
  </CContainer>
</template>
<script>
  import { ref } from "vue";
  import CONSTANTS from "@/constants";
  import { formatter } from "@/general";
  import {
    dataGridProductosArrendamientos,
    crudProductoArrendamiento
  } from "@/apis/rents";

  import LoadingCover from "@/components/containers/LoadingCover.vue";

  const fields = [
    {
      key: 'producto',
      label: "Producto",
      _style: 'text-align:center'
    },
    {
      key: 'fechas',
      label: 'Fechas',
      _style: 'text-align:center'
    },
    {
      key: 'valores',
      label: "Valores",
      _style: 'text-align:center'
    },
    {
      key: "estado",
      _style: "text-align:center"
    },
    {
      key: "options",
      label: "",
      _style: "text-align:center;"
    }
  ]

  export default ({
    name: "RentedProducts",
    data() {
      return {
        formatter,
        loading: false,
        fields,
        rentedProducts: [],
        idSelectedRentedProduct: "",
        rentContractIndex: ""
      }
    },
    components: {
      LoadingCover
    },
    methods: {
      async getData() {
        this.loading = true

        try {
          const response = await dataGridProductosArrendamientos(this, this.contractId)

          this.rentedProducts = response
        } catch {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      tryDelete(e, idRentedProduct) {
        e.stopPropagation()

        this.idSelectedRentedProduct = idRentedProduct

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar"
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red"

        this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteRentedProduct()
        }).catch(() => {
          this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert)
        })
      },
      async deleteRentedProduct() {
        this.loading = true

        try {
          await crudProductoArrendamiento(this, "delete", this.idSelectedRentedProduct);

          this.$store.commit("setAlert", {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          })
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: CONSTANTS.messages.notDoneDelete,
            show: 5
          })
        } finally {
          this.loading = false
        }
      }
    },
    setup() {
      const rootPath = ref("");
      const contractId = ref("");

      return {
        rootPath,
        contractId
      }
    },
    mounted() {
      this.contractId = this.$router.currentRoute.params.id;

      console.log(this.contractId);

      this.getData();
    }
  });
</script>
